export default {
  navSearch: false,
  overlayLoading: false,
  navLoading: false,
  navBack: false,
  drawer: !true
}
